<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="90px">
        <el-form-item label="手机号">
          <el-input v-model="searchData.mobile" size="small" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="注册渠道">
          <el-input v-model="searchData.registerChannelCode" size="small" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="注册时间">
          <el-date-picker
            style="width:250px;"
            size="small"
            v-model="searchData.timeSlot"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">搜索</el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <tp-table
        :tableData="list"
        :is-need-serial-number="true"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize"
    />

    <!-- 申请记录 -->
    <el-dialog title="申请记录" :visible.sync="dialogApply" width="80%">
      <MemberApplyList :memberId="applyMemberId"></MemberApplyList>
    </el-dialog>

    <!-- 加黑/白名单 -->
    <el-dialog :visible.sync="dialogRoster" width="50%">
      <div class="roster-form">
        <span>{{ rosterAlertMsg }}</span>
        <el-form ref="rosterForm" :model="rosterFormData" label-width="80px">
          <el-form-item label="备注：">
            <el-input
                placeholder="请输入备注"
                v-model="rosterFormData.remark"
                clearable
                type="textarea"
                size="small"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogRoster = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitRoster" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getListAPI, addRosterAPI } from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';
import MemberApplyList from '@/views/components/table-member-apply.vue';

const columns = [
  {
    label: '手机号',
    prop: 'mobile',
    minWidth: '120',
    customRender(h, row) {
      return <p>{row['mobile']}</p>
    }
  },
  {
    label: '姓名',
    prop: 'idName',
    minWidth: '120',
    customRender(h, row) {
      return <p>{row['idName']}</p>
    }
  },
  {
    label: '注册渠道',
    prop: 'registerChannelName',
    minWidth: '150',
    customRender(h, row) {
      return <p>{row['registerChannelName']}</p>
    }
  },
  {
    label: '注册时间',
    prop: 'createTime',
    minWidth: '180',
    customRender(h, row) {
      return <p>{row['createTime']}</p>
    }
  },
  {
    label: '申请次数',
    prop: 'applyNum',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['applyNum']}</p>
    }
  },
  {
    label: '最近一次登录渠道',
    prop: 'loginChannelName',
    minWidth: '150',
    customRender(h, row) {
      return <p>{row['loginChannelName']}</p>
    }
  },
  {
    label: '最近一次登录时间',
    prop: 'loginTime',
    minWidth: '180',
    customRender(h, row) {
      return <p>{row['loginTime']}</p>
    }
  },
  {
    label: '最近一次登录IP',
    prop: 'loginIp',
    minWidth: '150',
    customRender(h, row) {
      return <p>{row['loginIp']}</p>
    }
  },
  {
    label: '状态',
    prop: 'status',
    minWidth: '100',
    customRender(h, row) {
      return (
        <div>
          <el-tag v-show={row['status'] == 1} type="success" size="small">正常</el-tag>
          <el-tag v-show={row['status'] == 2} type="danger" size="small">注销</el-tag>
        </div>
      )
    }
  },
  {
    label: '操作',
    width: '180',
    fixed: 'right',
    customRender(h, row) {
      return (
        <div>
          <el-link
              disabled={!this.isShowBtn(this.AUTH_BTN.member_list_apply_list)}
              underline={false}
              type="primary"
              onClick={() => this.showApplyDialog(row.id)}
              style="margin: 2px;"
          >
            <span>申请记录</span>
          </el-link>

          <el-link
              disabled={!this.isShowBtn(this.AUTH_BTN.member_list_add_allow)}
              underline={false}
              type="primary"
              onClick={() => this.showAllowRosterDialog(row)}
              style="margin: 2px;"
          >
            <span>加入白名单</span>
          </el-link>

          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.member_list_add_block)}
            underline={false}
            type="primary"
            onClick={() => this.showBlockRosterDialog(row)}
            style="margin: 2px;"
          >
            <span>加入黑名单</span>
          </el-link>
        </div>
      )
    }
  }
];

export default {
  name: 'MemberList',
  mixins: [authBtnMixin],
  components: { MemberApplyList },
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        mobile: '',
        registerChannelCode: '',
        timeSlot: [],
        minCreateDate: '',
        maxCreateDate: ''
      },
      dialogApply: false,
      applyMemberId: undefined,
      dialogRoster: false,
      rosterAlertMsg: '',
      rosterFormData: {
        rosterType: undefined,
        mobile: '',
        remark: '',
      },
    }
  },
  provide() {
    return {
      context: this
    }
  },
  activated() {
    this.getList();
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const { mobile, registerChannelCode, timeSlot } = this.searchData;
      let params = { page: this.currentPage, pageSize: this.pageSize, mobile, registerChannelCode };
      if (timeSlot && timeSlot.length > 0) {
        params.minCreateDate = timeSlot[0] || '';
        params.maxCreateDate = timeSlot[1] || '';
      }
      const res = await getListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    showApplyDialog(memberId) {
      this.applyMemberId = memberId;
      this.dialogApply = true;
    },
    showAllowRosterDialog(row) {
      this.rosterAlertMsg = '此操作会将该用户加入白名单，是否继续？';
      this.rosterFormData.rosterType = 1;
      this.rosterFormData.mobile = row.mobile;
      this.rosterFormData.remark = '';
      this.dialogRoster = true;
    },
    showBlockRosterDialog(row) {
      this.rosterAlertMsg = '此操作会将该用户加入黑名单，是否继续？';
      this.rosterFormData.rosterType = 2;
      this.rosterFormData.mobile = row.mobile;
      this.rosterFormData.remark = '';
      this.dialogRoster = true;
    },
    // 加入黑/白名单
    submitRoster() {
      this.$confirm(`确定将该用户加入${this.rosterFormData.rosterType == 2 ? '黑' : '白'}名单吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          addRosterAPI(this.rosterFormData).then(() => {
            this.getList();
            this.$message.success('操作成功');
          })
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消操作' });
        })
        .finally(() => {
          this.dialogRoster = false;
        })
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 35px;
        .el-input {
          width: 250px;
        }
        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }
          .el-range-input {
            width: 35%;
          }
        }
      }
    }
  }
  .el-date-editor .el-range-separator {
    padding: 0;
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }

  .roster-form {
    width: 80%;
    font-size: 15px;
    line-height: 20px;
    & > span {
      display: flex;
      justify-content: center;
      font-weight: 500;
      margin: 10px 0;
    }
  }
}
</style>
